export const messages = {
  en: {
    maintainanceItem: {
      search: {
        title: 'Search Conditions',
        itemTitle: 'Please enter item name',
        titleType: 'Please select title type'
      },
      list: {
        title: 'Inspection Items'
      },
      table: {
        itemTitle: 'Name',
        titleType: 'Type',
        seq: 'Sequence',
        createTime: 'Create Time'
      },
      titleType: {
        single: 'Single Choice',
        multiple: 'Multiple Choice',
        shortAnswer: 'Short Answer'
      },
      form: {
        itemTitle: 'Name',
        itemTitlePlaceholder: 'Please enter name',
        itemTitleRequired: 'Name is required',
        titleType: 'Type',
        titleTypePlaceholder: 'Please select type',
        titleTypeRequired: 'Type is required',
        option: 'Option',
        optionPlaceholder: 'Please enter option content',
        optionRequired: 'Option content is required',
        seq: 'Sequence',
        seqPlaceholder: 'Please enter sequence',
        seqRequired: 'Sequence is required',
        seqNumber: 'Sequence must be a number'
      },
      add: {
        title: 'Add Item'
      },
      edit: {
        title: 'Edit Item'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this item?'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    maintainanceItem: {
      search: {
        title: '查询条件',
        itemTitle: '请输入问题名称',
        titleType: '请选择题目类型'
      },
      list: {
        title: '检查项'
      },
      table: {
        itemTitle: '名称',
        titleType: '类型',
        seq: '顺序',
        createTime: '创建时间'
      },
      titleType: {
        single: '单选',
        multiple: '多选',
        shortAnswer: '简答'
      },
      form: {
        itemTitle: '名称',
        itemTitlePlaceholder: '请输入名称',
        itemTitleRequired: '名称不能为空',
        titleType: '类型',
        titleTypePlaceholder: '请选择类型',
        titleTypeRequired: '类型不能为空',
        option: '选项',
        optionPlaceholder: '请输入选项内容',
        optionRequired: '选项内容不能为空',
        seq: '顺序',
        seqPlaceholder: '请输入顺序',
        seqRequired: '顺序不能为空',
        seqNumber: '顺序必须是数字'
      },
      add: {
        title: '添加检查项'
      },
      edit: {
        title: '修改检查项'
      },
      delete: {
        title: '确认操作',
        confirmText: '确定删除该题目吗?'
      },
      fetchError: '获取数据失败'
    }
  }
}